import { useParams } from "react-router-dom";
import { ONE_DAY_OF_MS } from "reports/utils/timeUtils";
import { useGeAndLtFromUrl } from "./reportUtils";
import { useEffect, useRef, useState } from "react";
import { ReportParams } from "reports/types";

const AKSR_DATA_TIMEOUT = 5 * 1000;

export function useShouldFetchFromAskr(
  /** if this boolean doesn't become true within AKSR_DATA_TIMEOUT, askrTimedOut becomes false */
  isDoneLoading: boolean,
  logName?: string
): {
  shouldFetchFromAskr: boolean;
  askrTimedOut: boolean;
} {
  const { ckey } = useParams() as ReportParams;
  const { ge, lt } = useGeAndLtFromUrl();
  // e.g. Sun Nov 6 - Fri Nov 11, /<tenant>/reports/eos/<line>?ge=1667790000000&lt=1668222000000
  const isWeekly = lt - ge >= 5 * ONE_DAY_OF_MS;
  const { processGroupName } = useParams<{ processGroupName: string }>();

  // ! unused, keeping temporarily in case we need to revert (doesn't work now because Askr DDA is missing multiple new fields available in Midgard DDA like "taggedNumberOfEvents", "untaggedNumberOfEvents", "manualRejectOutput", "totalPotentialOutput", "meanTimeToRecovery", "meanTimeBetweenFailures", "avgCycleTime")
  const shouldFetchFromAskr = Boolean(
    ckey === "false" &&
      isWeekly &&
      processGroupName &&
      ["All", "Line 1", "Line 2", "Line 3", "Line 4"].includes(processGroupName)
  );

  const [askrTimedOut, setAskrTimedOut] = useState(false);
  const timerRef = useRef<null | number>(null);
  // wait for 5 seconds for Askr data to come back, if it doesn't, query Midgard instead
  useEffect(() => {
    if (shouldFetchFromAskr) {
      if (isDoneLoading) {
        if (timerRef.current) {
          window.clearTimeout(timerRef.current);
        }
      } else {
        timerRef.current = window.setTimeout(() => {
          console.log(
            `⚠ Askr PnlBreakdown data didn't come back in time - querying Midgard instead${
              logName ? ` (${logName})` : ""
            }`
          );
          // TODO trace when Askr PnlBreakdown times out

          setAskrTimedOut(true);
        }, AKSR_DATA_TIMEOUT);
      }
    }
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, [shouldFetchFromAskr, isDoneLoading, logName]);

  return { shouldFetchFromAskr, askrTimedOut };
}
